export default __webpack_public_path__ + "static/images/ios-app.6c8f1c32.png";